import styles from "../index.module.less"
import { classModuleGenerator } from "@/utils"
const classnames = classModuleGenerator(styles)

function Product({ classs = [] }) {
  return (
    <section className={styles["product-container"]}>
      <h3 className="section__title">学大全日制特色班型</h3>
      <div className="section__inner">
        <ul className={classnames("product-list", "clearfix")}>
          {classs.map((model) => {
            return (
              <li
                className={styles["product-item"]}
                key={model._id}
                onClick={() => {
                  if (model.jumpUrl) window.open(model.jumpUrl)
                  else window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                <img src={model.coverUrl} alt="" />
                <h4>{model.name}</h4>
                {model.intros.map((intro) => {
                  return <p key={intro}>{intro}</p>
                })}
                <button className={styles["product-btn"]}>
                  {model.jumpGuide || "立即咨询"}
                </button>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default Product
